import { render, staticRenderFns } from "./WelcomePasswordChange.vue?vue&type=template&id=9a577ab0&scoped=true"
import script from "./WelcomePasswordChange.vue?vue&type=script&lang=js"
export * from "./WelcomePasswordChange.vue?vue&type=script&lang=js"
import style0 from "./WelcomePasswordChange.vue?vue&type=style&index=0&id=9a577ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a577ab0",
  null
  
)

export default component.exports